import { render, staticRenderFns } from "./mapJourney.vue?vue&type=template&id=3edd0b8a"
import script from "./mapJourney.ts?vue&type=script&lang=js&external"
export * from "./mapJourney.ts?vue&type=script&lang=js&external"
import style0 from "./mapJourney.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports